export default "__VITE_ASSET__CkJeihZn__"